<div class="loading-indicator-container" fxLayout="row wrap" fxLayoutAlign="start">
	<div
		class="loading-indicator-placeholder"
		fxFlex="33%"
		fxFlex.lt-md="50%"
		*ngFor="let i of placeholders"
	>
		<div class="blinker-container">
			<div class="blinker-sizer">
				<div class="blinker-wrapper">
					<div class="blinker"></div>
				</div>
			</div>
		</div>
	</div>
</div>
